import { notifications } from '@mantine/notifications';

export const showSuccess = (message: string, title = 'Success', autoClose: number | false = 3000) =>
    notifications.show({ title, message, color: 'green', autoClose });

export const showError = (message: string, title = 'Error', autoClose: number | false = 4000) =>
    notifications.show({ title, message, color: 'red', autoClose });

export const showWarning = (message: string, title = 'Warning', autoClose: number | false = 6000) =>
    notifications.show({ title, message, color: 'yellow', autoClose });
